import { render, staticRenderFns } from "./InfoEdit.vue?vue&type=template&id=08c7a8e2&scoped=true"
import script from "./InfoEdit.vue?vue&type=script&lang=js"
export * from "./InfoEdit.vue?vue&type=script&lang=js"
import style0 from "./InfoEdit.vue?vue&type=style&index=0&id=08c7a8e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c7a8e2",
  null
  
)

export default component.exports